import { Component, OnInit } from '@angular/core';
import { UtilsService } from './../utils.service';
import { ServiceService } from '../service.service';
import { AlertController,LoadingController } from '@ionic/angular';
import { async } from 'rxjs/internal/scheduler/async';
import { FormGroup, FormControl, Validator, Validators, FormBuilder } from '@angular/forms';
import validator from 'validator';
import moment from 'moment';
import { Router } from '@angular/router';
@Component({
  selector: 'app-recuperar-password',
  templateUrl: './recuperar-password.page.html',
  styleUrls: ['./recuperar-password.page.scss', '../../assets/scss/styles.scss'],
})
export class RecuperarPasswordPage implements OnInit {
  bandera = false;
  registerForm: FormGroup;
  isWeb:boolean = false;

  constructor(
    public services: ServiceService,
    public alertController: AlertController,
    private router: Router,
    private form: FormBuilder,
    public utils: UtilsService,
    private loadingController: LoadingController,
  ) { 
    this.isWeb = !this.services.isMovil();
    this.registerForm = this.form.group({
      userEmail: ['', [Validators.required, Validators.email] ],
      userPassword: ['', [
        Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z])\S{8,20}$/),
        Validators.minLength(8),
        Validators.required
      ]],
      userPasswordC: ['', [
        Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z])\S{8,20}$/),
        Validators.minLength(8),
        Validators.required
      ]],
  });
  }

  email: any;
  password: any;
  passwordC: any;

  ngOnInit() {
    this.getPromocionesByZone();
  }

  async onSubmit() {
    const loading = await this.loadingController.create({
      message: 'Activando espere...'
    });
    await loading.present();
      this.email = this.registerForm.get('userEmail').value;
      this.password = this.registerForm.get('userPassword').value;
      this.passwordC = this.registerForm.get('userPasswordC').value;

      if (this.password === this.passwordC) {
        this.bandera = false;
        
       await this.services.restaurarPassword(this.email, this.password).subscribe(async data => {
          loading.dismiss();
          if (data['succeful'] === 1) {
            
            const alert = await this.alertController.create({
              header: 'Activar cuenta',
              subHeader: '',
              message: data['mensaje'],
              buttons: ['OK'],
            });
            await alert.present();
            await alert.onDidDismiss()
            .then((data)=> {
              this.router.navigate(["/login"]);
            });
            
          }
        },
          async error => {
            loading.dismiss();
            let mensage = "Por favor intenta de Nuevo";
              switch(error.status){
                case 400:
                case 403:
                case 401:
                case 500:
                  mensage = error.error;
                  break;
              }
              const alert = await this.alertController.create({
                header: "",
                subHeader: "",
                message: mensage,
                buttons: ["OK"],
              });

            await alert.present();
            await alert.onDidDismiss();
          },
        );
      } else {
        await loading.present();
        this.bandera = true;
      }
  }

  home() {
    this.router.navigate(['/login'], { replaceUrl: true });
  }

  onLoadStart(video:any) {
    this.loading.dismiss();
  }

  promociones:any = [];
  objetoBanner:any = {};
  loading:HTMLIonLoadingElement;
  public async  getPromocionesByZone(){
    this.loading = await this.loadingController.create({
      message: 'Espere por favor ...', duration: 6000
    });
    await this.loading.present();

    let idZone = this.isWeb ? 11 : 10;
    (await this.services.getPromosByZone(idZone)).toPromise()
    .then((response : any ) => {
      if (Array.isArray(response) ) {
        this.promociones = response;
        if(this.promociones.length > 0){
          this.objetoBanner = this.promociones[0];
        }else{
          this.objetoBanner = {};
        }
      }else{
        this.promociones = [];
        this.services.showAlert("Ha ocurrido un error al obtener las promociones.");
      }
    }).catch((error : any ) => {
      this.loading.dismiss();
      this.services.showAlert("Ha ocurrido un error al obtener las promociones.");
    });


  }

  public getFileExtension(fileName: string = "") {
    return fileName.substring(fileName.lastIndexOf('.') + 1);
  }

}
